import { BOOST_CODE } from '@packages/types';
import { convertCentsToDollarsAndFormat } from '@packages/utils';

import { Text } from '@elements/text';
import { useTripStore } from '@store';
import { testProps } from '@utils';

import { useTravellersText } from './useTravellersText.hook';

export const SpecifiedItemsText = () => {
  const travellersText = useTravellersText();
  const tripExtrasSpecifiedItemsText = useTripStore(state => {
    const specifiedItemBoost = state.trip.boosts.find(
      b => b.code === BOOST_CODE.SPECIFIED_ITEM && b.isAdded,
    );

    return specifiedItemBoost?.boostProperty.specifiedItems?.map(
      i =>
        `${travellersText.find(t => t.travellerId === i.travellerId)?.name}: ${i.itemName} (${convertCentsToDollarsAndFormat(i.selectedValue * 100)})`,
    );
  });
  const plural = tripExtrasSpecifiedItemsText && tripExtrasSpecifiedItemsText.length > 1 ? 's' : '';
  if (!tripExtrasSpecifiedItemsText?.length) return null;

  return (
    <div>
      <Text {...testProps('policyDetails-specifiedItems-header')}>
        Specified items: {tripExtrasSpecifiedItemsText?.length} item{plural}
      </Text>
      <Text {...testProps('policyDetails-specifiedItems')}>
        {tripExtrasSpecifiedItemsText?.join(', ')}
      </Text>
    </div>
  );
};
